import { StepsLayout } from "@/components/layout/StepsLayout";
import LoadingScreen from "@/components/LoadingScreen";
import { useDeployContext } from "@/contexts/DeployContext";

export function DeployLayout({
    Sidebar,
    VisualArea,
    BottomContent
}: {
    Sidebar?: React.ReactNode;
    VisualArea: React.ReactNode;
    BottomContent?: React.ReactNode;
}) {
    const { loading } = useDeployContext();

    if (loading) {
        return <LoadingScreen />;
    }

    return <StepsLayout Sidebar={Sidebar} VisualArea={VisualArea} BottomContent={BottomContent} />;
}
